import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import TagsPage from "@/pages/tags/page";
import DetailPage from "@/pages/detail/page";
import SearchPage from "@/pages/search/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:categoryName", element: <CategoryPage /> },
      { path: "/tags/:tagName", element: <TagsPage /> },
      { path: "/detail/:id", element: <DetailPage /> },
      { path: "/search", element: <SearchPage /> },
      { path: "/news", element: <NewsPage /> },
      { path: "/news/:id", element: <NewsDetailPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;